
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JwtService } from 'src/app/jwt.service';
import { ClienteManager } from 'src/app/managers/cliente-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ConfigService } from 'src/app/services/config.service';
import { FilialService } from './../../services/filial.service';
import { CORE_IMPORTS } from 'src/app/providers/module-providers';

@Component({
    standalone: true,
    selector: 'app-card-login',
    templateUrl: './card-login.component.html',
    styleUrls: ['./card-login.component.css'],
    imports: [CORE_IMPORTS]
    
})
export class CardLoginComponent {
    public btnLoginDesabilado = false;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    public cpf_cnpj: string;

    constructor(
        private router: Router,
        private jwtService: JwtService,
        private clienteManager: ClienteManager,
        private snackBarManager: SnackbarManager,
        private filialService: FilialService,
        private config: ConfigService,                
    ) {
    }

    login(usuario: string, senha: string) {
        const urlRedirect = localStorage.getItem('urlRedirect')
        usuario = this.removerMascara(usuario);
        this.btnLoginDesabilado = true;
        if (usuario == '' || senha == '') {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar('Usuario ou senha inválido.', 'Fechar', 2000);
            return;
        }
        this.jwtService.login(usuario, senha).subscribe((res) => {
            if (res['status'] == false) {
                this.btnLoginDesabilado = false;
                this.snackBarManager.openSnackBar(res['mensagem'], 'Fechar', 2000);
            } else {
                this.config.cdFilial = res['filial'];
                localStorage.setItem('access_token', res['access_token']);
                localStorage.setItem('expires_at', res['expires_at']);
                localStorage.setItem('cd_usuario', res['cd_usuario']);
                localStorage.setItem('cd_cliente', res['cd_cliente']);
                localStorage.setItem('filial', res['filial']);
                localStorage.setItem('expires_at_seconds', res['expires_at_seconds']);                
                this.clienteManager.getClienteFilial(Number.parseInt(localStorage.getItem('filial')));                
                this.filialService.getFiliais();
                this.jwtService.temAcesso().subscribe((r: boolean) => {
                    if(!r){
                        this.snackBarManager.openSnackBar('Usuário não possui acesso ao Portal', 'Fechar', 2000);
                        this.jwtService.logout();
                        return
                    }
                    if (Number.parseInt(localStorage.getItem('cd_cliente')) != 0) {
                        this.clienteManager.getCliente();
                        if(urlRedirect){
                            this.router.navigateByUrl(urlRedirect);
                            localStorage.removeItem('urlRedirect');
                        }else{
                            this.router.navigateByUrl('/home');
                        }
                    } else {
                        if(urlRedirect){
                            this.router.navigateByUrl(urlRedirect);
                            localStorage.removeItem('urlRedirect');
                        }else{
                            this.router.navigateByUrl('/home');
                        }
                    }

                },
                (error: HttpErrorResponse) => {
                    this.btnLoginDesabilado = false;
                    this.snackBarManager.openSnackBar(error.error, 'Fechar', 2000);
                }
                )
                
            }
        }, (error: HttpErrorResponse) => {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar((error.status == 0 ? "Não foi possível estabeler conexão com o servidor" : error.error), 'Fechar', 2000);
        });
    }

    getCpfCnpjMask() {
        if (this.cpf_cnpj != undefined) {
            if (!isNaN(+this.removerMascara(this.cpf_cnpj))) {
                if (this.removerMascara(this.cpf_cnpj).length == 3) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})/, "$1.");
                } else if (this.removerMascara(this.cpf_cnpj).length == 4) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{1})/, "$1.$2");
                } else if (this.removerMascara(this.cpf_cnpj).length == 5) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{2})/, "$1.$2");
                } else if (this.removerMascara(this.cpf_cnpj).length == 6) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})/, "$1.$2.");
                } else if (this.removerMascara(this.cpf_cnpj).length == 7) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})(\d{1})/, "$1.$2.$3");
                } else if (this.removerMascara(this.cpf_cnpj).length == 8) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})(\d{2})/, "$1.$2.$3");
                } else if (this.removerMascara(this.cpf_cnpj).length == 9) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-");
                } else if (this.removerMascara(this.cpf_cnpj).length == 10) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3-$4");
                } else if (this.removerMascara(this.cpf_cnpj).length == 11) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
                } else if (this.removerMascara(this.cpf_cnpj).length == 12) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})/, "$1.$2.$3/$4");
                } else if (this.removerMascara(this.cpf_cnpj).length == 13) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1})/, "$1.$2.$3/$4-$5");
                } else if (this.removerMascara(this.cpf_cnpj).length == 14) {
                    this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
                    return this.cpf_cnpj = this.cpf_cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
                }
            } else {
                this.cpf_cnpj = this.removerMascara(this.cpf_cnpj);
            }
        }
    }

    removerMascara(string: string) {
        return string = string.split('.').join('').split('-').join('').split('/').join('');
    }    
}